import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.readAndThinkCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.readAndThinkCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.readAndThinkCollections.data.readAndThinkCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.readAndThinkCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
